import React from "react";
import { Stack } from "react-bootstrap";
import { PageHeader } from "../../../CommonElements/PageTitle";
import { useTranslation } from "react-i18next";
import { useSearchParams } from "react-router-dom";
import { Tabs } from "antd";
import BusReceptionList from "./BusReceptionList";
import { HugeiconsIcon } from "@hugeicons/react";
import { RealEstate01FreeIcons } from "@hugeicons/core-free-icons";
import { City03Icon } from "@hugeicons/core-free-icons/index";
import { Container } from "reactstrap";
import usePermissions from "@/utils/hooks/usePermissions";
import { MAKKAH_PERMISSIONS_FULL_NAMES } from "@/utils/constants";

const CenterReceptionJeddah = () => {
  const { t } = useTranslation();
  const [searchParams, setSearchParams] = useSearchParams();
  const { hasPermissionByName } = usePermissions();

   // Get current source from URL, default to 'nusuk' if not present
  const currentSource = searchParams.get("source") || "campaign";

  const handleTabChange = (key) => {
    setSearchParams({ source: key });
  };

  const tabItems = [
    hasPermissionByName(MAKKAH_PERMISSIONS_FULL_NAMES.list_center_reception_cards_from_ports) &&
    {
      key: "campaign",
      label: t("FROM_PORTS"),
      icon: <HugeiconsIcon size={14} icon={RealEstate01FreeIcons} />,
    },
    hasPermissionByName(MAKKAH_PERMISSIONS_FULL_NAMES.list_center_reception_cards_between_cities) &&
    {
      key: "between_cities",
      label: t("BETWEEN_CITIES"),
      icon: <HugeiconsIcon size={14} icon={City03Icon} />,
    },
  ].filter(Boolean);

  return (
    <Stack gap={3}>
      <PageHeader title={t("CENTER_RECEPTION_MAKKAH_ORGANIZER")} sticky={false} />
      <Container fluid>
        <Tabs
          activeKey={currentSource}
          items={tabItems}
          onChange={handleTabChange}
          className="mb-3"
        />
        <BusReceptionList port="JED" source={currentSource} />
      </Container>
    </Stack>
  );
};

export default CenterReceptionJeddah;
